export const PUSH_NOTI_IDENTIFIER = {};

export const PUSH_NOTI_DOMAIN = {
  ORDER: "order",
  REPORT: "report",
  SUBSCRIBE: "subscribe",
  DOBY: "doby",
  INSURANCE: "insurance",
  TYPHOON: "typhoon",
};

export const PUSH_NOTI_ACTION = {
  ORDER: {
    PUSH_TEST: "push_test",
  },
  REPORT: {
    // 리포트 발급 완료
    REPORT_ISSUED: "push_report_issued",
    // 집주인 다른집 리포트 발급 완료
    OWNER_HOUSE_ISSUED: "push_owner_house_issued",
    // 매매 리포트 주담대 상담 유도
    BUY_REPORT_MORTGAGE_CONSULT_NUDGE: "push_buy_report_mortgage_consult_nudge",
    // 대출상담(loan-relay) 상담사 답변 알림 → 탭 시 해당 상담 채팅으로 이동
    LOAN_CONSULT_AGENT_REPLY: "push_loan_consult_agent_reply",
    FIRSTAM_CS_AGENT_REPLY: "push_firstam_cs_agent_reply",
  },
  SUBSCRIBE: {
    // 구독 1차 변동 - 변동 발생
    CHANGE_DETECTED: "push_subscribe_change_detected",
    // 구독 2차 변동 - 변동사항 등기부 기재 완료
    CHANGE_FINALIZED: "push_subscribe_change_finalized",
  },
  DOBY: {
    // 계약서 보완 요청
    CONTRACT_AMEND_REQUEST: "push_doby_contract_amend_request",
    // 이체 완료
    TRANSFER_COMPLETED: "push_doby_transfer_completed",
    // 계약서 등록 요청
    CONTRACT_UPLOAD_REQUEST: "push_doby_contract_upload_request",
    // 입금 예정일까지 계약서 미등록 상태
    CONTRACT_NOT_UPLOADED: "push_doby_contract_not_uploaded",
    // 카드 등록 유도
    CARD_REGISTRATION_NUDGE: "push_doby_card_registration_nudge",
  },
  INSURANCE: {},
  TYPHOON: {},
};
